import { z } from "zod";

export const DEFAULT_CASINO_VIEW = "para-ti";

export const CASINO_VIEWS = ["para-ti", "recomendaciones", "nuevos-juegos", "mas-como-tu-favorito", "nuevos-juegos-para-ti", "tus-gustos", "tendencia", "favoritos-olvidados", "mecanica-favorita", "proveedor-favorito", "mejores-en-tu-ubicacion", "juegos", "lobby"] as const;

export type CasinoView = (typeof CASINO_VIEWS)[number];

export const casinoViewSchema = z.enum(CASINO_VIEWS);

const FILTER_FALLBACK_VIEW = "juegos" satisfies CasinoView;

export function firstQueryValue(value: string | string[] | undefined): string | undefined {
  if (Array.isArray(value)) {
    return value[0];
  }

  return value;
}

export function parseCasinoView(value: string | undefined): CasinoView {
  const parsed = casinoViewSchema.safeParse(value);

  return parsed.success ? parsed.data : DEFAULT_CASINO_VIEW;
}

export function resolveCasinoLobbyState(params: { view?: string; category?: string; provider?: string; collection?: string }): { view: CasinoView; hasFilterParams: boolean } {
  const hasFilterParams = Boolean(params.view || params.category || params.provider || params.collection);

  if (params.view) {
    return {
      view: parseCasinoView(params.view),
      hasFilterParams
    };
  }

  return {
    view: hasFilterParams ? FILTER_FALLBACK_VIEW : DEFAULT_CASINO_VIEW,
    hasFilterParams
  };
}
